module.exports = __webpack_public_path__ + "img/011.e6cade2f.png";